import { __extends, __decorate, __metadata } from 'tslib';
import { MagicConfigMixin } from '@gig/magic-common';
import { Emit, Component, Mixins } from 'vue-property-decorator';

var SweepstakesVerification = /** @class */ (function (_super) {
    __extends(SweepstakesVerification, _super);
    function SweepstakesVerification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SweepstakesVerification.prototype.onContinue = function () { };
    __decorate([
        Emit('onContinue'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SweepstakesVerification.prototype, "onContinue", null);
    SweepstakesVerification = __decorate([
        Component({
            name: 'sweepstakes-verification',
        })
    ], SweepstakesVerification);
    return SweepstakesVerification;
}(Mixins(MagicConfigMixin)));

export default SweepstakesVerification;
